// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i9diL","field":"styles_field__3bctp","fieldCol":"styles_fieldCol__21hVy","diffCol":"styles_diffCol__oM7Oz","diff":"styles_diff__5pvBE"};